




























































import { Component, Prop, Watch } from "vue-property-decorator";
import { WorkerDetailsModule } from "@/store/modules/workerDetails";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import WorkerPositionDto from "@/models/WorkerPositions/WorkerPositionDto";
import WorkerPositionStatus from "@/models/WorkerPositions/WorkerPositionStatus";
import ListUtils from "@/lib/listUtils";
import WorkType from "@/models/Shared/WorkType";

@Component({
  name: "WorkerPositionEdit",
})
export default class extends GiganautVueDialog {
  
  public dialog = false;

  @Prop({required: true})
  workerPositionId: string;
  workerPosition: WorkerPositionDto = new WorkerPositionDto();
  isVerified = false;
  workTypes: WorkType[] = [];
  isTemp = true;

  
 @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      //We need to fetch the latest copy - passing this in as a prop means updated at becomes stale on send edit
      const workerPosition = WorkerDetailsModule.positions.find((findWorkerPosition: WorkerPositionDto) => findWorkerPosition.id === this.workerPositionId);
      this.workerPosition = this.workerPosition = JSON.parse(JSON.stringify(workerPosition));
      this.isVerified = (this.workerPosition.status === WorkerPositionStatus.Verified);
      this.workTypes = this.workerPosition.workTypes;
    }
  }

  @Watch('workTypes')
  async onWorkTypesChanged(val: WorkType[], oldVal: WorkType[]) {
    this.isTemp = val.includes(WorkType.Temp);
  }

  get workTypeOptions() {
    return ListUtils.workTypes();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    if (this.isVerified) {
      this.workerPosition.status = WorkerPositionStatus.Verified;
    } else {
      this.workerPosition.status = WorkerPositionStatus.Pending;
    }
    this.workerPosition.workTypes = this.workTypes;
    await WorkerDetailsModule.editPosition(this.workerPosition);
    this.dialog = false;
  }
}
